import React, { useState } from 'react';
import Dashboard from './Dashboard';
import '../css/Campaign.css'; // Reusing the Campaign CSS for now

const Contacts = () => {
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  
  // Empty column definitions for the contacts datagrid
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Contact Name', width: 200 },
    { field: 'phone', headerName: 'Phone Number', width: 150 },
    { field: 'status', headerName: 'Status', width: 120 },
    { field: 'created', headerName: 'Added On', width: 150 }
  ];

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="campaign-container mx-5 mt-5 pt-5">
      <Dashboard />
      <div className="content-area mt-5">
        <div className="campaign-header">
          <h1>Contacts</h1>
          <button className="btn create-campaign-btn">
            <i className="fas fa-plus me-1"></i> Add Contact
          </button>
        </div>

        <div className="card campaign-tabs-container">
          <div className="card-header">
            <ul className="nav nav-tabs card-header-tabs">
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                  onClick={() => handleTabChange('all')}
                >
                  All Contacts
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'active' ? 'active' : ''}`}
                  onClick={() => handleTabChange('active')}
                >
                  Active
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'blocked' ? 'active' : ''}`}
                  onClick={() => handleTabChange('blocked')}
                >
                  Blocked
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'groups' ? 'active' : ''}`}
                  onClick={() => handleTabChange('groups')}
                >
                  Groups
                </button>
              </li>
            </ul>
          </div>
          <div className="card-body">
          <div className="search-container">
    <div className="input-group" style={{ height: '32px' }}>
      <span className="input-group-text p-0 px-2 d-flex align-items-center" style={{ height: '32px' }}>
        <i className="fas fa-search"></i>
      </span>
      <input 
        type="text" 
        className="form-control py-0" 
        placeholder="Search contacts"
        value={searchText}
        onChange={handleSearchChange}
        style={{ height: '32px' }}
      />
    </div>
  </div>
            
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    {columns.map((column) => (
                      <th key={column.field}>{column.headerName}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={columns.length} className="text-center">
                      <div className="coming-soon-container">
                        <h2 className="coming-soon-text">Coming Soon</h2>
                        <p>Contact management functionality is currently under development.</p>
                        {searchText && (
                          <p className="search-info">You searched for: <strong>{searchText}</strong></p>
                        )}
                        {activeTab !== 'all' && (
                          <p className="filter-info">Filter active: <strong>{activeTab}</strong></p>
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;